import styled from 'styled-components'
import { tokens } from "../../../assets/tokens";

const ProfileInfoStyled = styled.div`
  && {
    padding: 20px 0;
  }

  /* Cambiando de candidatura: contenido atenuado y sin interacción; la cabecera (paginador con
     spinner) sigue visible */
  &.is-loading > *:not(.profile-header) {
    opacity: 0.5;
    pointer-events: none;
    transition: opacity 0.2s ease;
  }

  .tabpanel_box {
    margin: 35px 0 12px -16px;
  }

  .tab-item {
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    border: 1px solid rgba(148,163,178,0.25);
    padding: 8px 16px;
    min-height: 40px;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    color: ${tokens.color.text.primary};
    margin-bottom: 0;
    background-color: rgba(148,163,178,0.18);
    margin-right: 3px;
  }
  
  /* Tabs como en la ficha de talent: 40 px, 14 px y la línea en el color del cliente */
  .MuiTabs-root {
    min-height: 40px;
  }

  .MuiTabs-indicator {
    background-color: ${props => props.theme.primary};
  }
  
  .MuiPaper-root.MuiStepper-root.MuiStepper-horizontal.MuiStepper-alternativeLabel {
    background-color: transparent;
    padding: 0;
    margin-bottom: 24px;
  }

  @media print {
    .profileStatsInfo-print{
      justify-content:space-between;
    }
    .otherInfoContainer {
      width: 50%;
      //padding: 35px 24px 35px 55px;
      margin-top: 20px;
      p.value{
        font-size: 11px !important;
      }
    }

    #boxProfileCiteGridContainer {
      padding-right: 0 !important;
      padding-left: 24px !important;
      margin-top: -4px;
    }

    .interview-otes-title-print{
      display: block !important;
      font-size: 18px !important;
    }
  }

  //InterviewNotes
  /* Las notas de la entrevista llevan su propio estilo (InterviewNotesPanel) */

  //Tabs
  .tab-item {
    text-transform: none;
  }
  
  .tab-item.Mui-selected{
    background-color: #fff;
  }

  .tab-item:not(.Mui-selected) {
    font-weight: 400;
  }

  .interview-otes-title-print{
    display:none;

  }
`

export default ProfileInfoStyled
